import { render, staticRenderFns } from "./study.vue?vue&type=template&id=0af1007d&scoped=true"
import script from "./study.vue?vue&type=script&lang=js"
export * from "./study.vue?vue&type=script&lang=js"
import style0 from "./study.vue?vue&type=style&index=0&id=0af1007d&prod&lang=scss&scoped=true"
import style1 from "./study.vue?vue&type=style&index=1&id=0af1007d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1007d",
  null
  
)

export default component.exports